import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { userContract } from 'shared/domain/user/userContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastUserError = makeErrorPublisher(
  userContract
);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedUserError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedUserError', error, messageId, uniqueId);
  broadcastUserError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
